<template>
  <div class="mainContainer">
    <p class="title">消息中心</p>
    <div class="innerContainer">
      <ul class="menu-nav">
        <li
          class="menuItem"
          :class="{ menuActive: index1 == index }"
          v-for="(item, index1) in typeList"
          :key="index1"
          @click="selectItems(index1)"
        >
          <div class="iconContain">
            <img :src="item.icon" class="munuIcon" />
            <p class="menuCount" v-if="item.unRead">{{ item.unRead }}</p>
          </div>
          <div class="menuName">{{ item.name }}</div>
          <div class="guanfang" v-if="index1 == 3">官方</div>
        </li>
      </ul>

      <div class="messageContainer">
        <div class="msgTitle">{{ typeList[index].name }}</div>
        <div
          class="sysMessage"
          v-infinite-scroll="getMessages"
          infinite-scroll-disabled="isAll"
          publicScroll
        >
          <div
            class="msgListItem"
            v-for="(item, index1) in messageList"
            :key="index1"
          >
            <div class="msgHeader">
              <div class="nameContain">
                <el-badge
                  is-dot
                  :hidden="item.n_isread == 1 || item.ns_isread == 1"
                >
                  <el-image :src="typeList[index].icon" class="message-icon" />
                </el-badge>
                <div class="typeName">
                  {{ index == 1 ? "顶端新闻-社区团队" : typeList[index].name }}
                </div>
              </div>
              <p class="date">
                {{ item.n_create_time || item.ns_create_time }}
              </p>
            </div>

            <div class="info">
              <p
                class="msgTitleInfo"
                :class="{
                  'is-read': item.n_isread == 1 || item.ns_isread == 1,
                }"
              >
                {{ item.n_title || item.ns_title }}
              </p>
              <p
                class="content"
                :class="{
                  'is-read': item.n_isread == 1 || item.ns_isread == 1,
                }"
              >
                {{ item.n_content || item.ns_content }}
              </p>
              <el-image
                :src="item.n_images || item.ns_images"
                class="message-img"
                v-if="item.n_images || item.ns_images"
                :preview-src-list="[item.n_images || item.ns_images]"
              />
              <p v-if="item.n_url || item.ns_url" class="linkPart">
                链接：<span
                  class="linkUrl"
                  @click.stop="linkViewFn(item.n_url || item.ns_url)"
                  >{{ item.n_url || item.ns_url }}</span
                >
              </p>
              <p
                class="appealBtn"
                v-if="item.n_title == '账号封禁通知'"
                @click="toAppeal()"
              >
                人工申诉 >
              </p>
            </div>

            <el-popover placement="bottom" width="160" trigger="hover">
              <div class="noticeCodeContain">
                <img
                  src="../../assets/new/PCMessageddmessage.png"
                  class="codeImg"
                />
                <p class="codeInfo">
                  打开 <span class="appName">顶端新闻APP</span> 我的-右上角“<img
                    src="../../assets/new/scan.png"
                    class="scanIcon"
                  />”扫码查看
                </p>
              </div>
              <el-button slot="reference">
                <img src="../../assets/new/q1rcode@2x.png" class="codeIcon" />
                <p class="btnText">扫码查看详情 >></p>
              </el-button>
            </el-popover>
          </div>
          <p class="noMore" v-if="isAll">暂无更多</p>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="linkViewShow"
      width="fit-content"
      top="5vh"
      class="linkViewContainer"
    >
      <iframe :src="link" style="height: 78vh; width: 500px"></iframe>
    </el-dialog>

    <BanDialog
      ref="banShow"
      :isShow="isBanned"
      :allowClose="true"
      @closeBan="isBanned = false"
    ></BanDialog>
  </div>
</template>

<script>
import { NEWS_HOST, SWNEWS_HOST, SWUSER_HOST } from "../../constants/apiHosts";
import axios from "axios";
import BanDialog from "../../components/banDialog.vue";

export default {
  data() {
    return {
      typeList: [
        {
          name: "系统通知",
          icon: require("../../assets/new/one.png"),
          url: "/api/notice/getNoticeAudit?",
          unRead: 0,
        },
        {
          name: "社区消息",
          icon: require("../../assets/new/commu.png"),
          url: "/api/notice/searchNoticeCommunity?",
          unRead: 0,
        },
        {
          name: "认证通知",
          icon: require("../../assets/new/cerfi.png"),
          url: "/api/notice/getNoticeAuth?",
          unRead: 0,
        },
        {
          name: "顶端小助手",
          icon: require("../../assets/new/helper.png"),
          url: "/api/notice/search?request_type=2&",
          unRead: 0,
        },
      ],
      index: 0,
      page: 0,
      size: 20,
      messageList: [],
      token: "",
      link: "",
      linkViewShow: false,
      isAll: false,
      isBanned: false,
    };
  },
  components: {
    BanDialog,
  },
  filters: {
    commentImgSize(item, compute) {
      let rate = 1;
      if (item.c_content_img_width) {
        rate = compute(
          [0.5625, 1, 1.3333],
          item.c_content_img_width / item.c_content_img_height
        );
      }
      switch (rate) {
        case 0.5625:
          // 9:16
          return "width:180px;height:320px;";
        case 1:
          // 1:1
          return "width:240px;height:240px;";
        case 1.3333:
          // 4:3
          return "width:320px;height:240px;";
        default:
          return "width:240px;height:240px;";
      }
    },
  },
  created() {
    this.token = localStorage.getItem("token");

    if (this.$route.query.isNotice) {
      this.index = 3;
    }
  },
  async mounted() {},
  methods: {
    selectItems(index) {
      this.index = index;

      this.page = 0;
      this.messageList = [];
      this.isAll = false;
      this.getMessages();
    },
    async getMessages() {
      this.page++;

      this.isAll = true;

      await this.$axios
        .get(
          `${this.index == 3 ? NEWS_HOST : SWNEWS_HOST}${
            this.typeList[this.index].url
          }page=${this.page}&size=${this.size}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.returnData.forEach((element) => {
              if (element.n_url && element.n_url.indexOf("token=") >= 0) {
                element.n_url += this.token;
              }
              if (element.n_url && element.n_url.indexOf("http") < 0) {
                element.n_url = "http://" + element.n_url;
              }
            });
            this.messageList = this.messageList.concat(
              res.data.data.returnData
            );
            if (res.data.data.returnData.length == this.size) {
              this.isAll = false;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });

      // 更新navbar的未读消息数量
      await this.$store.dispatch("common/getUnReadNum");
      // 更新未读消息数量
      this.typeList[this.index].unRead = await this.getUnReadNumByType(
        this.index
      );
      this.$store.state.common.unReadArray.forEach((item, index) => {
        this.typeList[index].unRead = item;
      });
    },
    linkViewFn(link) {
      if (link.indexOf("dingnews") >= 0 || link.indexOf("dingxinwen") >= 0) {
        this.link =
          link.indexOf("starSupportPlan") >= 0
            ? `${link}?isCreator=1&token=${localStorage.getItem("token")}`
            : link;
        this.linkViewShow = true;
      } else {
        window.open(link);
      }
    },
    getUnReadNumByType: async function () {
      if (this.index == 3) {
        const { data } = await axios.get(
          `${NEWS_HOST}/api/notice/getMpNoReadNums?type=1`
        );
        return data.data.count;
      } else if (this.index == 2) {
        const { data } = await axios.get(`${NEWS_HOST}/api/notice/getTypeNums`);
        return data.data.xt_auth.noread;
      } else if (this.index == 1) {
        const { data } = await axios.get(
          `${SWNEWS_HOST}/api/notice/getCommunityNoReadNums`
        );
        return data.data.count;
      } else {
        const { data } = await axios.get(
          `${NEWS_HOST}/api/notice/getMpNoReadNums?type=0`
        );
        return data.data.count;
      }
    },
    toAppeal() {
      this.getReason(localStorage.getItem("token"));
    },
    getReason(token) {
      this.$axios
        .get(`${SWUSER_HOST}/service/userban/getUserBanInfo?token=${token}`)
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.ban_type == 1) {
              this.$refs.banShow.getReason(token);
              this.isBanned = true;
            } else {
              this.$message({
                message: "你的账号状态已恢复，请严格遵守平台运营规范。",
                type: "warning",
              });
            }
          } else {
            console.log(res.data.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss">
.noticeCodeContain {
  .codeImg {
    width: 100%;
  }

  .codeInfo {
    color: #666666;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;

    .appName {
      color: #ff0000;
    }

    .scanIcon {
      height: 17px;
      margin-bottom: -5px;
    }
  }
}
</style>

<style lang="scss" scoped>
.mainContainer {
  height: 100%;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  border-radius: 8px;
  overflow: hidden;

  .title {
    color: #333333;
    font-family: "PingFang SC";
    font-size: 18px;
    font-weight: 500;
    line-height: 69px;
    padding-left: 24px;
    border-bottom: 1px solid #eeeeee;
  }

  .innerContainer {
    height: calc(100% - 70px);
    margin: 0 auto;
    display: flex;

    .menu-nav {
      width: 35%;
      padding: 16px 20px 0 24px;
      flex-shrink: 0;
      height: 100%;
      border-right: 1px solid #eeeeee;

      .menuItem {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 16px 20px;
        cursor: pointer;

        .iconContain {
          width: 48px;
          height: 48px;
          position: relative;

          .munuIcon {
            width: 48px;
            height: 48px;
          }

          .menuCount {
            border-radius: 16.8px;
            background: #f32432;
            color: #ffffff;
            font-family: "PingFang SC";
            font-size: 12px;
            font-weight: 400;
            line-height: 19px;
            letter-spacing: 0.12px;
            padding: 0 8px;
            position: absolute;
            top: -6px;
            right: -6px;
          }
        }

        .menuName {
          color: #333333;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 0.16px;
          margin-left: 16px;
        }

        .guanfang {
          border-radius: 2.4px;
          background: #ffe8e6;
          color: #f32432;
          font-family: "Source Han Serif CN";
          font-size: 13.2px;
          font-weight: 500;
          line-height: 17px;
          letter-spacing: 0.13px;
          padding: 0 5px;
          margin-left: 8px;
        }
      }

      .menuActive {
        background: #f8f8f8;
      }
    }

    .messageContainer {
      flex: 1;
      padding: 0 26px 0 20px;
      height: 100%;
      display: flex;
      flex-direction: column;

      .msgTitle {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 16px;
        font-weight: 500;
        line-height: 62px;
        border-bottom: 1px solid #eeeeee;
      }

      .sysMessage {
        width: 100%;
        flex: 1;
        overflow-y: auto;
        padding-right: 10px;

        .msgListItem {
          padding: 20px;
          width: 100%;
          background: #f8f8f8;
          margin-top: 24px;

          .msgHeader {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .nameContain {
              display: flex;
              align-items: center;

              /deep/.el-image__inner {
                width: 38px;
                height: 38px;
              }

              .typeName {
                color: #666666;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                margin-left: 8px;
              }
            }

            .date {
              color: #bbbbbb;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
            }
          }

          .info {
            padding-bottom: 20px;
            border-bottom: 1px solid #eeeeee;

            .msgTitleInfo {
              color: #333333;
              font-family: "PingFang SC";
              font-size: 16px;
              font-weight: 500;
              line-height: 22px;
              margin-top: 20px;
            }

            .content {
              color: #333333;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-top: 8px;
            }

            .is-read {
              color: #999999;
            }

            .message-img {
              width: 300px;
              margin: 10px 0 0 0;
            }

            /deep/.el-image__error {
              height: 200px;
            }

            .linkPart {
              margin: 10px 0 0 0;
              color: #409eff;
              cursor: pointer;
            }

            .appealBtn {
              cursor: pointer;
              color: #409eff;
              margin: 10px 0 0 0;
            }
          }

          .el-button {
            padding: 0;
            margin: 0;
            border: none;
            outline: none;
            background: transparent;
            box-shadow: none;
          }
          .el-button:hover,
          .el-button:focus,
          .el-button:active {
            background: transparent;
            border: none;
            outline: none;
            box-shadow: none;
          }

          /deep/.el-button {
            margin-top: 20px;

            span {
              display: flex;
              align-items: center;

              .codeIcon {
                height: 20px;
              }

              .btnText {
                color: #666666;
                font-family: "PingFang SC";
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
                margin-left: 4px;
              }
            }
          }
        }
      }

      .noMore {
        color: #999999;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 205px;
      }
    }
  }

  /deep/.linkViewContainer {
    .el-dialog {
      height: 90vh;

      .el-dialog__body {
        height: calc(100% - 30px);

        iframe {
          height: 100%;
        }
      }
    }
  }
}
</style>
